import { StatusType, Eligibility } from '../../../types'

export const mapEligibilityStatus = (
  eligibility: Eligibility | null
):
  | StatusType.Pending
  | StatusType.Approved
  | StatusType.Rejected
  | StatusType.CannotDefine
  | StatusType.NeedsReview
  | StatusType.Cancelled => {
  if (
    (eligibility?.status === 'live' || eligibility?.status === 'cancelled') &&
    eligibility?.results?.eligibilityStatus === 'pass'
  ) {
    return StatusType.Approved
  }

  if (eligibility?.status === 'pending' && eligibility?.results?.eligibilityStatus === 'fail') {
    return StatusType.NeedsReview
  }

  if (eligibility?.results?.eligibilityStatus === 'fail' || eligibility?.status === 'validation_request_failed') {
    return StatusType.Rejected
  }

  if (eligibility?.status === 'cannot_define_eligibility') {
    return StatusType.CannotDefine
  }

  if (eligibility?.status === 'cancelled') {
    return StatusType.Cancelled
  }

  return StatusType.Pending
}
